/* eslint-disable jsx-a11y/anchor-is-valid */
import { Form, FormGroup, Col, ControlLabel } from 'react-bootstrap';
import { BranchesSelector } from './branchesSelector';

export class SelectLocationsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLocations: false,
      locationItems: [],
    };
  }

  /**
   * Obtiene y procesa la lista de sedes disponibles desde las props.
   */
  getAppointmentLocationItems() {
    if (
      this.props.AppointmentLocations !== null &&
      this.props.AppointmentLocations !== undefined &&
      this.props.AppointmentLocations.length !== 0
    ) {
      this.getFriendlyLocationItems(this.props.AppointmentLocations);
    }
  }

  /**
   * Convierte la lista de sedes en un formato amigable para el BranchesSelector y actualiza el estado.
   * @param {array} locationItems - Lista de sedes originales.
   */
  getFriendlyLocationItems(locationItems) {
    var items = [];
    if (locationItems !== null && locationItems !== undefined) {
      for (var i = 0; i < locationItems.length; i++) {
        var locationItem = locationItems[i];
        if (locationItem !== null && locationItem !== undefined) {
          var item = {
            id: locationItem.Code,
            value: locationItem.InternalCode,
            text: locationItem.Name,
            url: locationItem.BranchUrl,
            address: locationItem.Address,
          };
          items.push(item);
        }
      }
      this.setState({
        locationItems: items,
        showLocations: true,
      });
    }
  }

  /**
   * Callback para manejar los ítems seleccionados en el BranchesSelector.
   * @param {array} checked - Ítems seleccionados.
   */
  getChecked(checked) {
    this.props.itemChecked(checked);
  }

  /**
   * Renderiza el componente SelectLocationsList (formulario y BranchesSelector).
   * @returns {JSX.Element} Elementos JSX a renderizar.
   */
  render() {
    return (
      <div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 box-background-gray" id="selectDropDownValidation">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-form-select-content">
            <h4>{parseText('Form.AppointmentLocation.Header')}</h4>
          </div>
          <hr />
          <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7 form-select-content">
            <Form horizontal>
              <FormGroup controlId="formControlsSelect">
                <Col componentClass={ControlLabel} sm={6} md={6}>
                  <ControlLabel>{parseText('Form.AppointmentLocation.LocationLabel')}</ControlLabel>
                </Col>
                <Col componentClass={ControlLabel} sm={6} md={6}>
                  <a className="btn btn-default" onClick={this.getAppointmentLocationItems.bind(this)}>
                    {parseText('Form.AppointmentLocation.AvailablePlacesButtonText')}
                  </a>
                </Col>
              </FormGroup>
            </Form>
          </div>
        </div>
        <div style={{ display: this.state.showLocations ? 'block' : 'none' }}>
          <BranchesSelector
            checkedSedes={this.getChecked.bind(this)}
            ListItems={this.state.locationItems}
            PlaceHolderText={parseText('Form.AppointmentLocation.SelectLocationLabel')}
          />
        </div>
      </div>
    );
  }
}
